import * as React from 'react'
import { Calendar, Clock } from 'react-feather'

import { UnreachableCaseError } from 'main/util/ts'

export enum IconKind {
  CALENDAR,
  CLOCK,
}

interface IProps {
  color: string
  kind: IconKind
}

export default function Icon(props: IProps) {
  const { color, kind } = props

  const iconProps = {
    color,
    height: 22,
    width: 22,
  }

  switch (kind) {
    case IconKind.CALENDAR:
      return <Calendar {...iconProps} />
    case IconKind.CLOCK:
      return <Clock {...iconProps} />
    default:
      throw new UnreachableCaseError(kind)
  }
}
